import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DigestPreview } from "@/components/DigestPreview";

export function ModuleDigestButton() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const isAdmin = ["master_admin", "admin"].includes(user?.role);
  const q = useQuery({ queryKey: ["module-digests"], queryFn: async () => (await api.get("/module-digests")).data, enabled: isAdmin, staleTime: 600000 });
  const mod = (q.data || []).find((m) => pathname === m.path || pathname.startsWith(m.path + "/"));
  if (!isAdmin || !mod) return null;
  const name = mod.label.split(" digest")[0];
  const open = async () => {
    setBusy(true);
    try { setPreview((await api.post(`/module-digests/${mod.module}/send-now`, null, { params: { preview: true } })).data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button className="pp-btn-ghost h-8 px-2.5 text-xs" onClick={open} disabled={busy} title={`${mod.label} — preview, then e-mail it to the configured recipients (auto-sends ${mod.schedule})`} data-testid={`module-digest-btn-${mod.module}`}>
        <Mail size={13} /> {busy ? "Loading…" : "E-mail digest"}
      </button>
      <DigestPreview preview={preview} name={name} onClose={() => setPreview(null)} onSend={async (edit) => (await api.post(`/module-digests/${mod.module}/send-now`, edit)).data} />
    </>
  );
}
